import { Controller } from "@hotwired/stimulus";

// The Affiliate Earnings column review. Keeps the preview's "mapped as" notes
// under each header in step with the column pickers, and only marks the order
// date required while rows are single orders (a totals report has no dates).
export default class extends Controller {
  static targets = ["column", "mapped", "aggregate", "dateField"];

  connect() {
    this.sync();
  }

  sync() {
    const byHeader = new Map();
    this.columnTargets.forEach((select) => {
      if (!select.value) return;
      byHeader.set(select.value, [
        ...(byHeader.get(select.value) || []),
        select.dataset.fieldLabel,
      ]);
    });

    this.mappedTargets.forEach((note) => {
      const labels = byHeader.get(note.dataset.header) || [];
      note.textContent = labels.join(", ");
      note.hidden = labels.length === 0;
    });

    if (this.hasAggregateTarget && this.hasDateFieldTarget) {
      this.dateFieldTarget.classList.toggle(
        "required",
        !this.aggregateTarget.checked
      );
    }
  }
}
